<script setup>
import { inject } from 'vue'

const store = inject('store');

</script>

<template>
  <h3 class="display-5 text-uppercase text-grey mb-4">Timetable</h3>

  <div class="row">
    <div class="col-sm-12 bg-black">
      <div class="table-responsive pt-3">
        <table class="table table-bordered table-dark table-sm text-center text-uppercase border-secondary align-middle">
          <thead>
            <tr>
              <th class="bg-black"><a href="https://www.timeanddate.com/worldclock/india/bengaluru" target="_blank" title="India time" class="text-decoration-none text-grey">Course time &middot; India &#8986;</a></th>
              <th class="bg-black text-grey">Mon</th>
              <th class="bg-black text-grey">Tue</th>
              <th class="bg-black text-grey">Wed</th>
              <th class="bg-black text-grey">Thu</th>
              <th class="bg-black text-grey">Fri</th>
              <th class="bg-black text-grey">Sat</th>
              <th class="bg-black text-grey">Sun</th>
            </tr>
          </thead>
          <tbody>        
            <tr v-for="(daily, index) of store.state.timetable" :key="index">
              <th class="bg-black">
                <div class="d-flex justify-content-center">
                  <img v-for="(item, index) of daily.thumbnail" :key="index" class="me-2 mb-2" width="100" height="auto" :src="require(`../assets/${item}`)" :alt="daily.name"  /><br>
                </div>
                <div class="d-flex justify-content-center m-auto" style="width: 13rem;">
                  <marquee class="badge text-bg-secondary text-black">{{ daily.name }}</marquee>
                </div>
              </th>
              <td class="bg-black" title="X">
                <span class="badge text-bg-warning">{{ daily.mon }}</span>
              </td>
              <td class="bg-black" title="X">
                <span class="badge text-bg-warning">{{ daily.tue }}</span>
              </td>
              <td class="bg-black" title="Y">
                <span class="badge text-bg-primary">{{ daily.wed }}</span>
              </td>
              <td class="bg-black" title="Y">
                <span class="badge text-bg-primary">{{ daily.thu }}</span>
              </td>
              <td class="bg-black" title="Z">
                <span class="badge text-bg-danger">{{ daily.fri }}</span>
              </td>
              <td class="bg-black" title="Z">
                <span class="badge text-bg-danger">{{ daily.sat }}</span>
              </td>
              <td class="bg-black" title="Origin">
                <span class="badge text-bg-light">{{ daily.sun }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th class="bg-black"><a href="https://www.timeanddate.com/worldclock/india/bengaluru" target="_blank" title="India time" class="text-decoration-none text-grey">Course time &middot; India &#8986;</a></th>
              <th class="bg-black text-grey">Mon</th>
              <th class="bg-black text-grey">Tue</th>
              <th class="bg-black text-grey">Wed</th>
              <th class="bg-black text-grey">Thu</th>
              <th class="bg-black text-grey">Fri</th>
              <th class="bg-black text-grey">Sat</th>
              <th class="bg-black text-grey">Sun</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>